<template>
  <div class="left_block users">
    <p class="header">Все пользователи</p>

    <UsersFilter
      :rows="rows"
      :search="search"
      @handle-change="handleChange"
      @restore="restoreChecked"
      @delete="deleteChecked"
      @create-user="openUserCreateModal"
      @create-leader="openLeaderCreateModal"
      @create-user-from-file="() => {}"
    />

    <UsersTable
      :is-loading="isLoading"
      :total-count="totalCount"
      :rows="rows"
      :users-list="usersList"
      @changePage="changePage"
      @click="openUserInfo"
      @delete="deleteUser"
      @restore="restoreUser"
      @init-sort="initSort"
    />

    <b-modal :active.sync="userCreateModal" has-modal-card scroll="keep">
      <CreateUser
        @add-user="addUser"
        @remove-user="removeUser"
        :new-users="newUsers"
        :modal-info="modal"
        @create-user="createUser"
        @close-modal="closeUserCreateModal"
      />
    </b-modal>

    <b-modal :active.sync="leaderCreateModal" has-modal-card scroll="keep">
      <CreateLeader :new-leader="newLeader" @create-leader="createLeader" @close-modal="closeLeaderCreateModal" />
    </b-modal>
  </div>
</template>

<script>
import UsersFilter from '@/components/leader/users/UsersFilter'
import UsersTable from '@/components/leader/users/UsersTable'
import CreateUser from '@/components/leader/users/CreateUser'
import CreateLeader from '@/components/leader/users/CreateLeader'
import { toastInfo } from '@/lib/toastCfg'



export default {
  components: {
    UsersFilter,
    UsersTable,
    CreateUser,
    CreateLeader,
  },
  data() {
    return {
      userCreateModal: false,
      leaderCreateModal: false,
      assignCourseModal: false,
      isLoading: true,
      modal: {
        header: 'Добавление студентов',
        button: 'Добавить',
        creation: true,
        action: 'create-user'
      },
      newUsers: [this.defaultUser()],
      newLeader: this.defaultLeader(),
      rows: {
        checked: []
      },
      search: {
        name: '',
        page: 1,
        trashed: false,
        sort: 'surname',
        sort_type: 'desc'
      }
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    totalCount() {
      return this.$store.state.allUsers.usersList.total
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    usersList() {
      return this.$store.state.allUsers.usersList.users
    },
    branchId() {
      return this.$store.state.auth.currentUser.branch.id
    }
  },
  methods: {
    defaultUser() {
      return {
        name: '',
        surname: '',
        patronymic: '',
        position: '',
        role: 2,
        branch_id: this.branchId
      }
    },
    defaultLeader() {
      return {
        name: '',
        surname: '',
        patronymic: '',
        position: '',
        role: 4,
        branch_id: this.branchId
      }
    },
    handleChange() {
      this.isLoading = true
      this.loadData()
    },
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('users?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setUsersList', { list: resp.data })
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    changePage(pageNumber) {
      this.search.page = pageNumber
      this.loadData()
    },
    restoreChecked() {
      this.rows.checked.forEach((user) => {
        this.restoreUser(user.id)
      })
      this.rows.checked = []
    },
    deleteChecked() {
      this.rows.checked.forEach((user) => {
        this.deleteUser(user.id)
      })
      this.rows.checked = []
    },
    restoreUser(userId) {
      this.$axios2
        .patch('users/' + userId)
        .then(() => {
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteUser(userId) {
      this.$axios2
        .delete('users/' + userId)
        .then(() => {
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    openUserInfo(userId) {
      this.$router.push('/users/' + userId.id)
    },
    openUserCreateModal() {
      this.newUsers = [this.defaultUser()]
      this.userCreateModal = true
    },
    openLeaderCreateModal() {
      this.newLeader = this.defaultLeader()
      this.leaderCreateModal = true
    },
    createUser() {
      this.newUsers.forEach((user) => {
        this.$axios2
          .post('users', user)
          .then(() => {
            this.$buefy.toast.open(toastInfo())
            this.closeUserCreateModal()
            this.loadData()
          })
          .catch(this.$errorToast)
      })
    },
    createLeader() {
      this.$axios2
        .post('users', this.newLeader)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.closeLeaderCreateModal()
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    addUser() {
      this.newUsers.push(this.defaultUser())
    },
    removeUser(index) {
      this.newUsers.splice(index, 1)
    },
    closeUserCreateModal() {
      this.userCreateModal = false
    },
    closeLeaderCreateModal() {
      this.leaderCreateModal = false
    },
  }
}
</script>
